module.exports = __webpack_public_path__ + "static/media/Tooltip-white-active.fa7f821e.svg";